<template>
  <div class="auditoria-page">
    <DataTable
      title="Documentos de Inscrição"
      subtitle="Listagem e exportação (inclui registros excluídos)"
      title-icon="fas fa-folder-open"
      :data="items"
      :columns="columns"
      :loading="loading"
      :custom-filters="filters"
      search-placeholder="Buscar por título, tipo ou descrição..."
      empty-title="Nenhum documento encontrado"
      empty-message="Não há documentos para os concursos permitidos."
      empty-icon="fas fa-folder-open"
      :show-view="false"
      :show-edit="false"
      :show-delete="false"
      @filter="onFilter"
    >
      <template #header-actions>
        <button class="btn btn-success" @click="exportar" :disabled="exporting">
          <i :class="exporting ? 'fas fa-spinner fa-spin' : 'fas fa-download'"></i>
          {{ exporting ? 'Exportando...' : 'Exportar' }}
        </button>
      </template>

      <template #cell-deleted_at="{ value }">
        <span v-if="value" class="badge badge-danger">Excluído</span>
        <span v-else class="badge badge-success">Ativo</span>
      </template>

      <template #cell-caminho_arquivo="{ value }">
        <a
          v-if="value"
          :href="value"
          target="_blank"
          rel="noopener noreferrer"
          class="btn btn-sm btn-outline-primary"
        >
          <i class="fas fa-external-link-alt"></i>
          Visualizar
        </a>
        <span v-else>-</span>
      </template>
    </DataTable>
  </div>
</template>

<script>
import axios from 'axios'
import DataTable from '@/components/admin/DataTable.vue'

export default {
  name: 'AuditoriaDocumentosInscricao',
  components: { DataTable },
  data() {
    return {
      loading: false,
      exporting: false,
      items: [],
      concursos: [],
      tableFilters: { search: '', concurso_id: '' },
      columns: [
        { key: 'id', label: 'Doc ID', sortable: true },
        { key: 'inscricao.id', label: 'Inscrição', sortable: true },
        { key: 'inscricao.concurso.titulo', label: 'Concurso', sortable: true },
        { key: 'inscricao.vaga.cargo', label: 'Cargo', sortable: true },
        { key: 'inscricao.cadastro.nome', label: 'Candidato', sortable: true },
        { key: 'titulo', label: 'Título', sortable: true },
        { key: 'tipo', label: 'Tipo', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'created_at', label: 'Criado em', sortable: true, type: 'date' },
        { key: 'caminho_arquivo', label: 'Anexo', sortable: false },
        { key: 'inscricao.deleted_at', label: 'Inscrição', sortable: true },
        { key: 'deleted_at', label: 'Documento', sortable: true }
      ],
      filters: [{ key: 'concurso_id', label: 'Concurso', placeholder: 'Todos os concursos', options: [] }]
    }
  },
  async mounted() {
    await Promise.all([this.carregarConcursos(), this.carregar()])
  },
  methods: {
    async carregarConcursos() {
      try {
        const { data } = await axios.get('/ps/auditoria/concursos')
        this.concursos = Array.isArray(data) ? data : []
        this.filters[0].options = this.concursos.map(c => ({
          value: c.id,
          label: `${c.prefeitura} - ${c.titulo}`
        }))
      } catch (e) {
        console.error('Erro ao carregar concursos auditoria (filtros):', e)
      }
    },
    async carregar(params = {}) {
      this.loading = true
      try {
        const { data } = await axios.get('/ps/auditoria/documentos-inscricao', { params })
        const items = Array.isArray(data) ? data : []
        // Agrupar por inscrição e ordenar por data de criação (desc) dentro do grupo
        this.items = items.sort((a, b) => {
          const aInscricao = a?.inscricao?.id ?? 0
          const bInscricao = b?.inscricao?.id ?? 0
          if (aInscricao !== bInscricao) return aInscricao - bInscricao
          const aDate = new Date(a?.created_at || 0).getTime()
          const bDate = new Date(b?.created_at || 0).getTime()
          return bDate - aDate
        })
      } catch (e) {
        console.error('Erro ao carregar documentos auditoria:', e)
        this.$sweet.showError('Erro ao carregar documentos')
      } finally {
        this.loading = false
      }
    },
    onFilter(filters) {
      this.tableFilters = filters || { search: '', concurso_id: '' }
    },
    async exportar() {
      this.exporting = true
      try {
        this.$sweet.showInfo('Gerando arquivo Excel...')
        const response = await axios.get('/ps/auditoria/documentos-inscricao/exportar-excel', {
          params: this.tableFilters,
          responseType: 'blob'
        })

        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `auditoria_documentos_inscricao_${new Date().getTime()}.csv`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        this.$sweet.showSuccess('Arquivo exportado com sucesso!')
      } catch (e) {
        console.error('Erro ao exportar documentos auditoria:', e)
        this.$sweet.showError('Erro ao exportar dados')
      } finally {
        this.exporting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auditoria-page {
  .badge {
    padding: 4px 8px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
  }
  .badge-success {
    background: rgba(40, 167, 69, 0.1);
    color: #28a745;
  }
  .badge-danger {
    background: rgba(220, 53, 69, 0.1);
    color: #dc3545;
  }
}
</style>

